import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";

type PortalRole =
  | "SUPERADMIN"
  | "DD_ACCOUNT_MANAGER"
  | "ORG_ADMIN"
  | "TERRITORY_SALES_MANAGER"
  | "SALES"
  | "ADMIN"
  | "FI_MANAGER";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: PortalRole | PortalRole[];
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole) {
    const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    // SuperAdmin and DD_ACCOUNT_MANAGER bypass only when they are in the allowed set
    const internalBypass = (user?.role === "SUPERADMIN" || user?.role === "DD_ACCOUNT_MANAGER") &&
      (allowedRoles.includes("SUPERADMIN") || allowedRoles.includes("DD_ACCOUNT_MANAGER"));
    if (internalBypass) {
      return <>{children}</>;
    }
    if (!allowedRoles.includes(user?.role as PortalRole)) {
      return <Navigate to="/apps" replace />;
    }
  }

  return <>{children}</>;
}







